import React from 'react'
import NavLink from '../Routes/NavLink'

import BuildingCard from '../Building/BuildingCard.jsx'

import { buildings } from '../../core/controllers/Buildings'
import { buildingStatistics } from '../../helpers/Building/BuildingStatistics'

export default class AllBuildingStatsWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            totalSpaces: 0,
            totalVacant: 0,
            totalLateRent: 0,
            totalOccupied: 0,
            totalMaintenance: 0
        };
    }

    componentDidMount() {
        var self = this;
        buildings.getAllBuildingStats(function(response) {
            buildingStatistics.determineStatistics(response.data, function() {
                self.setState({
                    totalSpaces: buildingStatistics.totalSpaces,
                    totalVacant: buildingStatistics.totalVacant,
                    totalLateRent: buildingStatistics.totalLateRent,
                    totalOccupied: buildingStatistics.totalOccupied,
                    totalMaintenance: buildingStatistics.totalMaintenance
                })
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        const totalSpaces = this.state.totalSpaces;
        const totalVacant = this.state.totalVacant;
        const totalLateRent = this.state.totalLateRent;
        const totalOccupied = this.state.totalOccupied;
        const totalMaintenance = this.state.totalMaintenance;
        if(totalSpaces == 0) {
            // don't display anything
            return (
                <div></div>
            )
        } else {
            return (
                <div class="col-md-4">
                    <div class="card">
                        <div class="header">
                            <h4 class="title"><i class="fa fa-cube"></i><small><i class="pe-7s-angle-right"></i></small> All Space Statistics</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="effective_date">Total Spaces</label>
                                        <input type="number" disabled class="form-control" value={totalSpaces} />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="effective_date">Total Vacant</label>
                                        <input type="number" disabled class="form-control" value={totalVacant} />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="effective_date">Total Occupied</label>
                                        <input type="number" disabled class="form-control" value={totalOccupied} />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="effective_date">Total Late Rent</label>
                                        <input type="number" disabled class="form-control" value={totalLateRent} />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="effective_date">Total Maintenance</label>
                                        <input type="number" disabled class="form-control" value={totalMaintenance} />
                                    </div>
                                </div>
                            </div>
                            <div class="footer">
                                <hr/>
                                <div class="legend">
                                    <NavLink to={"/buildings/"}>
                                    <button type="button" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" >
                                    Go To Buildings
                                    </button>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Buildings/AllBuildingStatsWidget.jsx